export const sliderGalleryLoghi = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-loghi .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    // cssMode: true,
    loop: true,
    slidesPerView: 3,
    spaceBetween: 0,
    threshold: 10,
    speed: 2000,
    freeMode: false,
    // longSwipesRatio: 2,
    resistance: false,

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.closest(".slider-gallery-loghi").querySelector(".swiper-button-next"),
      prevEl: el.closest(".slider-gallery-loghi").querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      // Quando la larghezza della finestra è >= 640px
      640: {
        slidesPerView: 4,
        // spaceBetween: 20,
      },
      // Quando la larghezza della finestra è >= 1023px
      1023: {
        slidesPerView: 6,
        // spaceBetween: 20,
      },
    },
  }),
};
